import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getReadableAccessLevel } from '../access-control/utils';

export default function AccessControlModal({ 
  showConfirmModal, 
  handleCancelAccessChange, 
  handleConfirmAccessChange, 
  pendingAccessChange, 
}) {
  return (
    <Modal show={showConfirmModal} onHide={handleCancelAccessChange}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Access Change</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to change all camera access to {pendingAccessChange?.newType ? getReadableAccessLevel(pendingAccessChange.newType) : ''}?
        This will affect all cameras for this user.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleCancelAccessChange}>Cancel</Button>
        <Button 
          onClick={handleConfirmAccessChange}
          bsStyle={pendingAccessChange?.newType === 'No Access' ? 'danger' : 'primary'}
        >
          Confirm Change
        </Button>
      </Modal.Footer>
    </Modal>
  );
} 